import React, { Fragment, useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { toInteger } from 'lodash';

import { withStyles } from '@material-ui/core/styles';

import Pager from 'src/utils/Pager';
import agm from '../../services/agm'
import Alerts from '../../utils/alerts';

import Results from './Results';

import {
    Box,
    InputLabel,
    Select,
    MenuItem,
    makeStyles,
    Grid,
    Card,
    TablePagination,
    DialogTitle,
    Divider,
    DialogContent,
    Dialog,
    colors,
    Typography,
    Button,
    TextField,
    InputAdornment,
    SvgIcon,
    FormControl,
    CardContent,
    Checkbox,
    FormControlLabel
} from '@material-ui/core';

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.cyan[400],
        '&$checked': {
            color: colors.cyan[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


import { Search as SearchIcon } from 'react-feather';
import { IoMdCart } from "react-icons/io";

var Item = IoMdCart;

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    container: {
        maxHeight: 415,
        minHeight: 415
    }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
    { name: 'Código', field: 'item.codigo', size: -1, sortable: 1, exportable: 0, wrap: 0 },
    { name: 'Nome', field: 'item.nome', size: -1, sortable: 1, exportable: 0, wrap: 0 },
    { name: 'Tipo', field: '(item.tipo) ? item.tipo.nome : "Não Informado"', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Categoria', field: '(item.aplicacao) ? item.aplicacao.nome : "Não Informado"', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Valor Custo', field: 'formatDecimal(item.custo, "0.00")', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Valor Material', field: 'formatDecimal(item.valor, "0.00")', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Valor Instalação', field: 'formatDecimal(item.instalacao, "0.00")', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Estoque', field: 'formatDecimal(item.estoque, "0.00")', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Unidade', field: '(item.unidadeProduto) ? item.unidadeProduto.nome : "???"', size: -1, sortable: 0, exportable: 1, wrap: 0 },
];

const defaultEmptyMessage = "Nenhuma Despesa Foi Encontrado.";

const defaultfullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: defaultEmptyMessage,
    columns: defaultResultColumns
};

const defaultCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: defaultEmptyMessage,
    columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const visions = [
    { id: 2, name: 'Despesa pelo nome', refine: 2, label: 'Nome do produto contendo', history: 0 },
    { id: 1, name: 'Despesa pelo código', refine: 1, label: 'Código do produto', history: 0 }
];

const defaultState = {
    loaded: false,
    records: 10,
    pages: 0,
    page: 0,
    count: 0,
    rows: []
}


const defaultFilter = {
    pagina: 0,
    registros: 10,
    palavrachave: '',
    ordenacao: 'asc',
    ordem: '',
    estoque: 1,
    ativo: true,
    tipo: -1,
    controlado: true,
    carregado: true,
    visao: visions[0]
}

const defaultDependencies = {
    stocks: [],
    types: []
}


const Find = ({ open, selectMode, closeFind, selectExpense, values }) => {

    const classes = useStyles();

    const [filter, setFilter] = useState(defaultFilter);
    const [keyword, setKeyword] = useState("");
    const [stock, setStock] = useState(1);
    const [type, setType] = useState(-1);
    const [query, setQuery] = useState(visions[0]);
    const [selected, setSelected] = useState(null);
    const [page, setPage] = useState(0);
    const [records, setRecords] = useState(10);
    const [resultset, setResultset] = useState(defaultState);
    const [dependencies, setDependencies] = useState(defaultDependencies);
    const [qtdLoaded, setQtdLoaded] = useState(true);
    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});

    const handleSelect = (item) => () => {
        setSelected(item);
    };

    const changeQtdLoaded = (event) => {
        setPage(0);
        setQtdLoaded(event.target.checked)
        changeFilter(query, keyword, page, records, stock, type, event.target.checked);
    }

    const changeQuery = (event) => {
        setQuery(event.target.value);
        setPage(0);
        changeFilter(event.target.value, keyword, page, records, stock, type, qtdLoaded);
    }

    const changeKeyword = (event) => {
        setKeyword(event.target.value);
        setPage(0);
        changeFilter(query, event.target.value, page, records, stock, type, qtdLoaded);
    }

    const changeStock = (event) => {
        setStock(event.target.value);
        setPage(0);
        changeFilter(query, keyword, page, records, event.target.value, type, qtdLoaded);
    }

    const changeType = (event) => {
        setType(event.target.value);
        setPage(0);
        changeFilter(query, keyword, page, records, stock, event.target.value, qtdLoaded);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        changeFilter(query, keyword, newPage, records, stock, type, qtdLoaded);
    };

    const handleChangeRowsPerPage = (event) => {
        var rowsPerPage = parseInt(event.target.value, 10);
        setRecords(rowsPerPage);
        setPage(0);
        changeFilter(query, keyword, page, rowsPerPage, stock, type, qtdLoaded);
    };

    const refreshItems = () => {
        agm.post('/produtos/consultar/estoque', { filtro: filter }, {
        }).then((response) => {
            if (!response.data.error) {
                setResultset({
                    loaded: true,
                    pages: toInteger((response.data.count / filter.registros)) + 1,
                    page: filter.pagina,
                    count: response.data.count,
                    rows: response.data.rows
                });
            } else {
                setResultset(defaultState);
            }
        }).catch((error) => {
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const loadDependencies = ((value) => {
        agm.get('/produtos/filtro/-1', {}, {}).then((response) => {
            if (!response.data.error) {
                setDependencies({
                    stocks: response.data.estoques,
                    types: response.data.tipos
                });
            } else {
                return defaultDependencies;
            }
        }).catch((error) => {
            console.error(error);
        })
    });

    useEffect(() => {
        if (!resultset.loaded) {
            loadDependencies();
            setSelected(null);
            refreshItems();
        }
        return
    }, []);

    const changeFilter = (query, keyword, page, rows, stock, type, qtdLoaded) => {
        const value = {
            pagina: page,
            registros: rows,
            palavrachave: keyword,
            ordenacao: 'asc',
            ordem: 'nome',
            estoque: stock,
            ativo: true,
            tipo: type,
            controlado: true,
            visao: query,
            carregado: qtdLoaded
        }
        setFilter(value);
        agm.post('/produtos/consultar/estoque', { filtro: value }, {
        }).then((response) => {
            if (!response.data.error) {
                setResultset({
                    loaded: true,
                    records: records,
                    pages: toInteger((response.data.count / value.registros)) + 1,
                    page: value.pagina,
                    count: response.data.count,
                    rows: response.data.rows
                });
            } else {
                setResultset(defaultState);
            }
        }).catch((error) => {
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    return (
        <Fragment>
            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth>
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Buscar por Despesa
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box >
                        <Card>
                            <CardContent>

                                <Grid
                                    container
                                    spacing={2}
                                    xs="auto"
                                >

                                    <Grid item
                                        md={12}
                                        xs={12}
                                    >

                                        <Grid container spacing={1}>

                                            <Grid item
                                                md={2}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="stock">Estoque</InputLabel>
                                                    <Select notched
                                                        required={true}
                                                        fullWidth={true}
                                                        label="Estoque"
                                                        variant="outlined"
                                                        id="stock"
                                                        name="stock"
                                                        value={stock}
                                                        onChange={changeStock}
                                                        inputProps={{
                                                            name: 'stock',
                                                            id: 'stock',
                                                        }}
                                                    >

                                                        {dependencies.stocks.map((stock) => (
                                                            <MenuItem key={stock.id} value={stock.id}>{stock.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>


                                            </Grid>

                                            <Grid item
                                                md={2}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="type">Tipo</InputLabel>
                                                    <Select notched
                                                        required={true}
                                                        fullWidth={true}
                                                        label="Tipo"
                                                        variant="outlined"
                                                        id="type"
                                                        name="type"
                                                        value={type}
                                                        onChange={changeType}
                                                        inputProps={{
                                                            name: 'type',
                                                            id: 'type',
                                                        }}
                                                    >
                                                        <MenuItem key={-1} value={-1}>{'Todos'}</MenuItem>
                                                        {dependencies.types.map((type) => (
                                                            <MenuItem key={type.id} value={type.id}>{type.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>


                                            </Grid>

                                            <Grid item
                                                md={2}
                                                xs={12}>

                                                <FormControl variant="outlined" margin="none" fullWidth>
                                                    <InputLabel shrink htmlFor="query">Pesquisa</InputLabel>
                                                    <Select notched
                                                        required={true}
                                                        fullWidth={true}
                                                        label="Pesquisa"
                                                        variant="outlined"
                                                        id="query"
                                                        name="query"
                                                        value={query}
                                                        onChange={changeQuery}
                                                        inputProps={{
                                                            name: 'query',
                                                            id: 'query',
                                                        }}
                                                    >
                                                        {visions.map((view) => (
                                                            <MenuItem key={view.id} value={view}>{view.name}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item
                                                md={3}
                                                xs={12}
                                            >
                                                <TextField
                                                    fullWidth
                                                    margin="none"
                                                    disabled={!query.refine}
                                                    onChange={changeKeyword}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SvgIcon
                                                                    fontSize="small"
                                                                    color="action"
                                                                >
                                                                    <SearchIcon />
                                                                </SvgIcon>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    placeholder={"Refinar pesquisa por, " + query.label}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>


                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>
                                                <FormControlLabel
                                                    control={<ColorCheckbox
                                                        checked={qtdLoaded}
                                                        onChange={changeQtdLoaded} name="qtdloads" />}
                                                    label="Quantidade Maior que Zero"
                                                />
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid item
                                        md={12}
                                        xs={12}
                                    >
                                        <Grid container
                                            fullWidth
                                            direction="row"
                                            justify="flex-start"
                                            alignItems="flex-start"
                                        >

                                            <Grid item
                                                md="auto"
                                                xs="auto"
                                            >

                                                <TablePagination
                                                    component="div"
                                                    className={classes.pager}
                                                    page={page}
                                                    rowsPerPage={records}
                                                    count={resultset.count}
                                                    labelRowsPerPage="Linhas por página"
                                                    labelDisplayedRows={({ from, to, count }) => `Encontrados: ${count}, Apresentando de: ${from} a ${to}`}
                                                    onChangePage={handleChangePage}
                                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                                    ActionsComponent={Pager}
                                                    SelectProps={{
                                                        inputProps: { 'aria-label': 'Linhas por página' },
                                                        native: false
                                                    }}
                                                />

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>

                        <br></br>

                        <Card>
                            <CardContent>


                                <Grid
                                    container
                                    spacing={2}
                                    xs="auto"
                                >
                                    <Grid item
                                        md={12}
                                        xs={12}
                                    >

                                        <Results
                                            resultset={resultset}
                                            resultModes={defaultResultModes}
                                            icon={IoMdCart}
                                            vision={{}}
                                            selectedMode={selectMode}
                                            openEdition={() => { }}
                                            openDeletion={() => { }}
                                            openTreatment={() => { }}
                                            openExportDialog={false}
                                            selected={selected}
                                            handleSelect={handleSelect}
                                            selectExpense={selectExpense}
                                            values={values}
                                            stock={stock}
                                        />

                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>

                    </Box>

                    <Divider />

                    <Box my={1}>
                        <Grid container
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                            spacing={1}  >
                            <Grid item >
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                        selectExpense(values, selected, stock);
                                    }}>
                                    Adicionar
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                        closeFind();
                                    }}>
                                    Cancelar
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>

                </DialogContent>

            </Dialog>

        </Fragment >
    );
};

export default Find;
